module.exports = __webpack_public_path__ + "img/BP.321686ea.png";